import axios from "axios";
import config from "./config";

type getByParams = {
    filter?: {},
    sort?: {},
    page?: number
}

type postParams = {
    id: number,
    fields: {}
}

const UserApi = {


    current: async () => {
        try {
            const response = await axios.get(config.host + '/api/private/user/current', {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }
            });
            return response.data;
        } catch (error) {
            throw new Error('Unable to get current user');
        }
    },

    get: async (id: number) => {

    },

    getBy: async ({filter, sort = {id: 'desc'}, page = 1} : getByParams) => {



    },

    post: async ({id, fields}: postParams) => {

        try {
            const data = JSON.stringify(fields);
            const response = await axios.post(config.host + '/api/private/user/' + id, data,{
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }
            });
            return response.data;
        } catch (error) {
            throw new Error('Unable to get current user');
        }

    },

    put: async () => {

    },

    delete: async (id: number) => {
        const response = await axios.delete(config.host + '/api/private/user/' + id,{
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('token')
            }
        });
    }

}

export default UserApi;
